var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 162.49,
    height: 32.8649,
    viewBox: "0 0 162.49 32.8649",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_0_4",
    maskUnits: "userSpaceOnUse",
    x: -0.510239,
    y: 0.894152,
    width: 31,
    height: 31,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.510239,
    y: 0.894152,
    width: 31,
    height: 31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4038 12.5885L7.29054 6.47521L5.12062 8.64513L11.2847 14.8082H0.489761V17.9801H10.9292L5.37648 23.5328L7.5464 25.7027L13.4038 19.8443V30.8942H16.5757V20.1002L22.1773 25.7018L24.3472 23.5318L18.7964 17.9801H29.4898V14.8082H18.4409L24.603 8.64513L22.4341 6.47521L16.5757 12.3336V1.89415H13.4038V12.5885Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.4038 12.5885L7.29054 6.47521L5.12062 8.64513L11.2847 14.8082H0.489761V17.9801H10.9292L5.37648 23.5328L7.5464 25.7027L13.4038 19.8443V30.8942H16.5757V20.1002L22.1773 25.7018L24.3472 23.5318L18.7964 17.9801H29.4898V14.8082H18.4409L24.603 8.64513L22.4341 6.47521L16.5757 12.3336V1.89415H13.4038V12.5885Z",
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4038 12.5885H13.8936C13.8936 12.7866 13.7743 12.9652 13.5912 13.041C13.4082 13.1168 13.1976 13.0749 13.0575 12.9348L13.4038 12.5885ZM7.29054 6.47521L6.94423 6.12889C7.13549 5.93763 7.44559 5.93763 7.63686 6.12889L7.29054 6.47521ZM5.12062 8.64513L4.77433 8.99147C4.68247 8.89962 4.63086 8.77505 4.63086 8.64515C4.63085 8.51525 4.68245 8.39067 4.77431 8.29881L5.12062 8.64513ZM11.2847 14.8082L11.631 14.4619C11.7711 14.6019 11.813 14.8126 11.7372 14.9956C11.6614 15.1786 11.4828 15.298 11.2847 15.298V14.8082ZM0.489761 14.8082H0C0 14.5377 0.219273 14.3185 0.489761 14.3185V14.8082ZM0.489761 17.9801V18.4699C0.219273 18.4699 0 18.2506 0 17.9801H0.489761ZM10.9292 17.9801V17.4903C11.1273 17.4903 11.3059 17.6097 11.3817 17.7927C11.4575 17.9757 11.4156 18.1863 11.2755 18.3264L10.9292 17.9801ZM5.37648 23.5328L5.03017 23.8791C4.8389 23.6879 4.8389 23.3778 5.03017 23.1865L5.37648 23.5328ZM7.5464 25.7027L7.89275 26.049C7.8009 26.1409 7.67632 26.1925 7.54642 26.1925C7.41652 26.1925 7.29194 26.1409 7.20009 26.0491L7.5464 25.7027ZM13.4038 19.8443L13.0575 19.4981C13.1975 19.358 13.4082 19.3161 13.5912 19.3919C13.7743 19.4677 13.8936 19.6462 13.8936 19.8443H13.4038ZM13.4038 30.8942V31.3839C13.1333 31.3839 12.9141 31.1646 12.9141 30.8942H13.4038ZM16.5757 30.8942H17.0655C17.0655 31.1646 16.8462 31.3839 16.5757 31.3839V30.8942ZM16.5757 20.1002H16.0859C16.0859 19.9021 16.2053 19.7235 16.3883 19.6477C16.5713 19.5719 16.7819 19.6138 16.922 19.7539L16.5757 20.1002ZM22.1773 25.7018L22.5236 26.0481C22.3323 26.2393 22.0222 26.2393 21.8309 26.0481L22.1773 25.7018ZM24.3472 23.5318L24.6935 23.1856C24.8848 23.3768 24.8847 23.6869 24.6935 23.8782L24.3472 23.5318ZM18.7964 17.9801L18.4501 18.3264C18.31 18.1863 18.2681 17.9756 18.3439 17.7926C18.4197 17.6096 18.5983 17.4903 18.7964 17.4903V17.9801ZM29.4898 17.9801H29.9795C29.9795 18.2506 29.7602 18.4699 29.4898 18.4699V17.9801ZM29.4898 14.8082V14.3185C29.7602 14.3185 29.9795 14.5377 29.9795 14.8082H29.4898ZM18.4409 14.8082V15.298C18.2429 15.298 18.0643 15.1787 17.9885 14.9957C17.9126 14.8127 17.9545 14.602 18.0946 14.4619L18.4409 14.8082ZM24.603 8.64513L24.9494 8.29889C25.1406 8.49016 25.1406 8.80018 24.9494 8.99142L24.603 8.64513ZM22.4341 6.47521L22.0878 6.12889C22.1796 6.03703 22.3042 5.98543 22.4342 5.98544C22.5641 5.98546 22.6886 6.03709 22.7805 6.12897L22.4341 6.47521ZM16.5757 12.3336L16.922 12.6799C16.7819 12.82 16.5713 12.8619 16.3883 12.7861C16.2053 12.7103 16.0859 12.5317 16.0859 12.3336H16.5757ZM16.5757 1.89415V1.40439C16.8462 1.40439 17.0655 1.62366 17.0655 1.89415H16.5757ZM13.4038 1.89415H12.9141C12.9141 1.62366 13.1333 1.40439 13.4038 1.40439V1.89415ZM13.4038 12.5885L13.0575 12.9348L6.94423 6.82152L7.29054 6.47521L7.63686 6.12889L13.7501 12.2422L13.4038 12.5885ZM7.29054 6.47521L7.63686 6.82152L5.46693 8.99144L5.12062 8.64513L4.77431 8.29881L6.94423 6.12889L7.29054 6.47521ZM5.12062 8.64513L5.46691 8.29879L11.631 14.4619L11.2847 14.8082L10.9384 15.1546L4.77433 8.99147L5.12062 8.64513ZM11.2847 14.8082V15.298H0.489761V14.8082V14.3185H11.2847V14.8082ZM0.489761 14.8082H0.979523V17.9801H0.489761H0V14.8082H0.489761ZM0.489761 17.9801V17.4903H10.9292V17.9801V18.4699H0.489761V17.9801ZM10.9292 17.9801L11.2755 18.3264L5.72279 23.8791L5.37648 23.5328L5.03017 23.1865L10.5829 17.6338L10.9292 17.9801ZM5.37648 23.5328L5.72279 23.1865L7.89272 25.3564L7.5464 25.7027L7.20009 26.0491L5.03017 23.8791L5.37648 23.5328ZM7.5464 25.7027L7.20006 25.3565L13.0575 19.4981L13.4038 19.8443L13.7502 20.1906L7.89275 26.049L7.5464 25.7027ZM13.4038 19.8443H13.8936V30.8942H13.4038H12.9141V19.8443H13.4038ZM13.4038 30.8942V30.4044H16.5757V30.8942V31.3839H13.4038V30.8942ZM16.5757 30.8942H16.0859V20.1002H16.5757H17.0655V30.8942H16.5757ZM16.5757 20.1002L16.922 19.7539L22.5236 25.3555L22.1773 25.7018L21.8309 26.0481L16.2294 20.4465L16.5757 20.1002ZM22.1773 25.7018L21.8309 25.3555L24.0009 23.1855L24.3472 23.5318L24.6935 23.8782L22.5236 26.0481L22.1773 25.7018ZM24.3472 23.5318L24.0008 23.8781L18.4501 18.3264L18.7964 17.9801L19.1427 17.6338L24.6935 23.1856L24.3472 23.5318ZM18.7964 17.9801V17.4903H29.4898V17.9801V18.4699H18.7964V17.9801ZM29.4898 17.9801H29V14.8082H29.4898H29.9795V17.9801H29.4898ZM29.4898 14.8082V15.298H18.4409V14.8082V14.3185H29.4898V14.8082ZM18.4409 14.8082L18.0946 14.4619L24.2567 8.29884L24.603 8.64513L24.9494 8.99142L18.7873 15.1545L18.4409 14.8082ZM24.603 8.64513L24.2567 8.99136L22.0877 6.82144L22.4341 6.47521L22.7805 6.12897L24.9494 8.29889L24.603 8.64513ZM22.4341 6.47521L22.7804 6.82152L16.922 12.6799L16.5757 12.3336L16.2294 11.9873L22.0878 6.12889L22.4341 6.47521ZM16.5757 12.3336H16.0859V1.89415H16.5757H17.0655V12.3336H16.5757ZM16.5757 1.89415V2.38391H13.4038V1.89415V1.40439H16.5757V1.89415ZM13.4038 1.89415H13.8936V12.5885H13.4038H12.9141V1.89415H13.4038Z",
    fill: "#5170FF",
    mask: "url(#path-1-outside-1_0_4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 225"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 94",
    x: 72.9875,
    y: 2.00543,
    width: 3.53286,
    height: 13.2143,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 84",
    x: 51.0544,
    y: 2.0936,
    width: 3.92353,
    height: 28.2905,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 146",
    d: "M40.8615 2.01846H44.603L40.8729 26.3444H37.1313L40.8615 2.01846Z",
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 101",
    x: 95.1119,
    y: 2.00542,
    width: 3.92353,
    height: 28.3786,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 85",
    x: 53.703,
    y: 6.74771,
    width: 3.26984,
    height: 2.65009,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 129",
    x: 75.2452,
    y: 6.77987,
    width: 3.26984,
    height: 2.65009,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 102",
    x: 81.2048,
    y: 25.7633,
    width: 17.8306,
    height: 1.9627,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 96",
    x: 58.5376,
    y: 2.00543,
    width: 11.5986,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 97",
    x: 58.5376,
    y: 7.85981,
    width: 11.9706,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 98",
    x: 58.5376,
    y: 13.6498,
    width: 11.9706,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 99",
    x: 58.5376,
    y: 7.85981,
    width: 3.9254,
    height: 7.36013,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 100",
    x: 66.5828,
    y: 2.00543,
    width: 3.9254,
    height: 5.85417,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-15-outside-2_0_4",
    maskUnits: "userSpaceOnUse",
    x: 62.1053,
    y: 16.012,
    width: 14,
    height: 17,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 62.1053,
    y: 16.012,
    width: 14,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1053 24.7025C75.1053 28.9502 72.4282 32.3939 69.1259 32.3939C65.8236 32.3938 63.1464 28.9501 63.1464 24.7025C63.1465 20.4551 65.8237 17.0121 69.1259 17.012C72.4281 17.012 75.1052 20.455 75.1053 24.7025ZM72.3134 24.5951C72.3133 21.2881 70.9044 18.6069 69.1669 18.6068C67.4292 18.6068 66.0204 21.288 66.0204 24.5951C66.0204 27.9022 67.4292 30.5833 69.1669 30.5833C70.9045 30.5832 72.3134 27.9021 72.3134 24.5951Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.1053 24.7025C75.1053 28.9502 72.4282 32.3939 69.1259 32.3939C65.8236 32.3938 63.1464 28.9501 63.1464 24.7025C63.1465 20.4551 65.8237 17.0121 69.1259 17.012C72.4281 17.012 75.1052 20.455 75.1053 24.7025ZM72.3134 24.5951C72.3133 21.2881 70.9044 18.6069 69.1669 18.6068C67.4292 18.6068 66.0204 21.288 66.0204 24.5951C66.0204 27.9022 67.4292 30.5833 69.1669 30.5833C70.9045 30.5832 72.3134 27.9021 72.3134 24.5951Z",
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1053 24.7025H75.5764V24.7025L75.1053 24.7025ZM69.1259 32.3939L69.1258 32.8649H69.1259V32.3939ZM63.1464 24.7025L62.6753 24.7025V24.7025H63.1464ZM69.1259 17.012V16.541H69.1258L69.1259 17.012ZM72.3134 24.5951H72.7844V24.595L72.3134 24.5951ZM69.1669 18.6068L69.1669 18.1357H69.1669V18.6068ZM66.0204 24.5951L65.5493 24.595V24.5951H66.0204ZM69.1669 30.5833V31.0544H69.1669L69.1669 30.5833ZM75.1053 24.7025H74.6343C74.6343 28.8073 72.0646 31.9228 69.1259 31.9228V32.3939V32.8649C72.7918 32.8649 75.5764 29.0931 75.5764 24.7025H75.1053ZM69.1259 32.3939L69.1259 31.9228C66.1872 31.9228 63.6174 28.8072 63.6174 24.7025H63.1464H62.6753C62.6753 29.093 65.4599 32.8648 69.1258 32.8649L69.1259 32.3939ZM63.1464 24.7025L63.6174 24.7025C63.6176 20.598 66.1873 17.4832 69.1259 17.4831L69.1259 17.012L69.1258 16.541C65.4601 16.5411 62.6755 20.3121 62.6753 24.7025L63.1464 24.7025ZM69.1259 17.012V17.4831C72.0645 17.4831 74.6341 20.598 74.6343 24.7025L75.1053 24.7025L75.5764 24.7025C75.5762 20.312 72.7917 16.541 69.1259 16.541V17.012ZM72.3134 24.5951L72.7844 24.595C72.7844 22.8809 72.4202 21.3057 71.8087 20.1417C71.2086 18.9998 70.298 18.1358 69.1669 18.1357L69.1669 18.6068L69.1668 19.0778C69.7733 19.0779 70.4359 19.5545 70.9747 20.58C71.5019 21.5834 71.8423 23.0022 71.8423 24.5951L72.3134 24.5951ZM69.1669 18.6068V18.1357C68.0357 18.1357 67.1251 18.9997 66.5251 20.1417C65.9135 21.3056 65.5494 22.8809 65.5493 24.595L66.0204 24.5951L66.4914 24.5951C66.4915 23.0021 66.8318 21.5833 67.359 20.5799C67.8978 19.5544 68.5604 19.0778 69.1669 19.0778V18.6068ZM66.0204 24.5951H65.5493C65.5493 26.3093 65.9134 27.8846 66.525 29.0485C67.1251 30.1904 68.0357 31.0544 69.1669 31.0544V30.5833V30.1123C68.5604 30.1123 67.8978 29.6357 67.359 28.6103C66.8317 27.6068 66.4914 26.188 66.4914 24.5951H66.0204ZM69.1669 30.5833L69.1669 31.0544C70.298 31.0543 71.2086 30.1903 71.8087 29.0484C72.4203 27.8845 72.7844 26.3092 72.7844 24.5951H72.3134H71.8423C71.8423 26.188 71.502 27.6068 70.9747 28.6102C70.4359 29.6356 69.7733 30.1122 69.1668 30.1123L69.1669 30.5833Z",
    fill: "#5170FF",
    mask: "url(#path-15-outside-2_0_4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtract_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-17-outside-3_0_4",
    maskUnits: "userSpaceOnUse",
    x: 41.2082,
    y: 8.00501,
    width: 8,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 41.2082,
    y: 8.00501,
    width: 8,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2082 26.005C48.2082 23.7175 48.0543 21.3449 47.7551 19.2316C47.456 17.1182 47.0169 15.1977 46.4641 13.5802C45.9114 11.963 45.2555 10.6801 44.5334 9.80481C43.8112 8.92942 43.0368 8.47864 42.2551 8.47864V12.5187C42.3479 12.4931 42.4408 12.4786 42.5344 12.4786C43.8707 12.6772 45.4279 16.8819 45.428 24.2745C45.428 24.8608 45.4187 25.4386 45.4016 26.005H48.2082Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.2082 26.005C48.2082 23.7175 48.0543 21.3449 47.7551 19.2316C47.456 17.1182 47.0169 15.1977 46.4641 13.5802C45.9114 11.963 45.2555 10.6801 44.5334 9.80481C43.8112 8.92942 43.0368 8.47864 42.2551 8.47864V12.5187C42.3479 12.4931 42.4408 12.4786 42.5344 12.4786C43.8707 12.6772 45.4279 16.8819 45.428 24.2745C45.428 24.8608 45.4187 25.4386 45.4016 26.005H48.2082Z",
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2082 26.005L48.6793 26.005L48.6793 26.4761H48.2082V26.005ZM47.7551 19.2316L48.2215 19.1655L48.2215 19.1655L47.7551 19.2316ZM46.4641 13.5802L46.9098 13.4279L46.9098 13.4279L46.4641 13.5802ZM44.5334 9.80481L44.8968 9.50504L44.8968 9.50505L44.5334 9.80481ZM42.2551 8.47864H41.7841V8.00759H42.2551V8.47864ZM42.2551 12.5187L42.3801 12.9728L41.7841 13.1369V12.5187H42.2551ZM42.5344 12.4786V12.0076H42.5692L42.6036 12.0127L42.5344 12.4786ZM45.428 24.2745L45.899 24.2745V24.2745H45.428ZM45.4016 26.005V26.4761H44.9161L44.9308 25.9908L45.4016 26.005ZM48.2082 26.005L47.7372 26.005C47.7372 23.737 47.5844 21.3866 47.2887 19.2976L47.7551 19.2316L48.2215 19.1655C48.5241 21.3032 48.6793 23.698 48.6793 26.005L48.2082 26.005ZM47.7551 19.2316L47.2887 19.2976C46.9927 17.2068 46.5595 15.3161 46.0184 13.7325L46.4641 13.5802L46.9098 13.4279C47.4742 15.0792 47.9192 17.0296 48.2215 19.1655L47.7551 19.2316ZM46.4641 13.5802L46.0184 13.7325C45.4756 12.1446 44.8426 10.9198 44.1701 10.1046L44.5334 9.80481L44.8968 9.50505C45.6685 10.4405 46.3472 11.7815 46.9098 13.4279L46.4641 13.5802ZM44.5334 9.80481L44.1701 10.1046C43.4956 9.28703 42.8417 8.94969 42.2551 8.94969V8.47864V8.00759C43.232 8.00759 44.1268 8.57181 44.8968 9.50504L44.5334 9.80481ZM42.2551 8.47864H42.7262V12.5187H42.2551H41.7841V8.47864H42.2551ZM42.2551 12.5187L42.1301 12.0645C42.2565 12.0297 42.3918 12.0076 42.5344 12.0076V12.4786V12.9497C42.4899 12.9497 42.4393 12.9565 42.3801 12.9728L42.2551 12.5187ZM42.5344 12.4786L42.6036 12.0127C43.1533 12.0944 43.5999 12.553 43.9504 13.1174C44.3165 13.7068 44.6512 14.5285 44.9361 15.5526C45.507 17.6051 45.899 20.5492 45.899 24.2745L45.428 24.2745L44.9569 24.2745C44.9569 20.6073 44.5702 17.7527 44.0285 15.8051C43.757 14.8291 43.4519 14.1003 43.1501 13.6145C42.8329 13.1036 42.5836 12.9622 42.4652 12.9446L42.5344 12.4786ZM45.428 24.2745H45.899C45.899 24.8658 45.8897 25.4483 45.8724 26.0192L45.4016 26.005L44.9308 25.9908C44.9477 25.4289 44.9569 24.8559 44.9569 24.2745H45.428ZM45.4016 26.005V25.534H48.2082V26.005V26.4761H45.4016V26.005Z",
    fill: "#5170FF",
    mask: "url(#path-17-outside-3_0_4)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 107",
    x: 116.188,
    y: 2.00543,
    width: 3.92353,
    height: 28.3786,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 113",
    x: 137.518,
    y: 2.00543,
    width: 3.92353,
    height: 28.4557,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 108",
    x: 118.837,
    y: 6.76351,
    width: 3.26984,
    height: 2.65009,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 114",
    x: 140.159,
    y: 6.76351,
    width: 3.26984,
    height: 2.65009,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 120",
    x: 145.23,
    y: 19.4624,
    width: 1.9627,
    height: 16.0449,
    transform: "rotate(-90 145.23 19.4624)",
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 121",
    x: 151.297,
    y: 17.4996,
    width: 3.14032,
    height: 3.9254,
    transform: "rotate(-90 151.297 17.4996)",
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 115",
    x: 123.608,
    y: 2.00543,
    width: 11.0546,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 133",
    x: 102.281,
    y: 2.09553,
    width: 11.0546,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 110",
    x: 102.281,
    y: 24.4351,
    width: 11.8145,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 116",
    x: 123.608,
    y: 24.4351,
    width: 11.4425,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 119",
    x: 123.608,
    y: 13.2201,
    width: 11.4425,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 138",
    x: 145.23,
    y: 11.6499,
    width: 16.0527,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 139",
    x: 145.23,
    y: 2.00543,
    width: 16.0527,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 140",
    x: 145.234,
    y: 6.82748,
    width: 16.0527,
    height: 1.57016,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 90",
    x: 145.23,
    y: 28.4214,
    width: 16.0567,
    height: 1.9627,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 89",
    x: 145.23,
    y: 2.84457,
    width: 3.9254,
    height: 10.3755,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 111",
    x: 102.281,
    y: 2.83538,
    width: 3.9254,
    height: 23.1694,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 117",
    x: 123.608,
    y: 13.2201,
    width: 3.9254,
    height: 12.785,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 112",
    x: 110.17,
    y: 2.09553,
    width: 3.9254,
    height: 22.9797,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 118",
    x: 131.497,
    y: 2.00543,
    width: 3.9254,
    height: 12.7848,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 91",
    x: 145.23,
    y: 20.6104,
    width: 3.9254,
    height: 8.24334,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-40-outside-4_0_4",
    maskUnits: "userSpaceOnUse",
    x: 75.1252,
    y: -0.605577,
    width: 23,
    height: 25,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 75.1252,
    y: -0.605577,
    width: 23,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2892 9.0077L80.3654 4.08388L78.6174 5.83095L83.5822 10.7948H75.5295V13.3485H83.2961L78.8234 17.8202L80.5715 19.5683L85.2892 14.8495V23.7489H87.8429V15.0565L92.3537 19.5673L94.1017 17.8202L89.631 13.3485H97.1252V10.7948H89.3449L94.3078 5.83095L92.5607 4.08388L87.8429 8.80067V0.394423H85.2892V9.0077Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.2892 9.0077L80.3654 4.08388L78.6174 5.83095L83.5822 10.7948H75.5295V13.3485H83.2961L78.8234 17.8202L80.5715 19.5683L85.2892 14.8495V23.7489H87.8429V15.0565L92.3537 19.5673L94.1017 17.8202L89.631 13.3485H97.1252V10.7948H89.3449L94.3078 5.83095L92.5607 4.08388L87.8429 8.80067V0.394423H85.2892V9.0077Z",
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2892 9.0077H85.6837C85.6837 9.16723 85.5876 9.31105 85.4402 9.3721C85.2928 9.43315 85.1231 9.39941 85.0103 9.2866L85.2892 9.0077ZM80.3654 4.08388L80.0866 3.8049C80.2406 3.65094 80.4903 3.65098 80.6443 3.80498L80.3654 4.08388ZM78.6174 5.83095L78.3385 6.10987C78.2645 6.03589 78.2229 5.93554 78.2229 5.83091C78.2229 5.72628 78.2645 5.62594 78.3385 5.55197L78.6174 5.83095ZM83.5822 10.7948L83.8611 10.5159C83.9739 10.6287 84.0077 10.7983 83.9466 10.9457C83.8856 11.0931 83.7417 11.1892 83.5822 11.1892V10.7948ZM75.5295 10.7948H75.135C75.135 10.577 75.3116 10.4004 75.5295 10.4004V10.7948ZM75.5295 13.3485V13.7429C75.3116 13.7429 75.135 13.5664 75.135 13.3485H75.5295ZM83.2961 13.3485V12.9541C83.4556 12.9541 83.5994 13.0502 83.6605 13.1976C83.7215 13.345 83.6878 13.5147 83.5749 13.6275L83.2961 13.3485ZM78.8234 17.8202L78.5445 18.0991C78.4705 18.0251 78.429 17.9248 78.429 17.8202C78.429 17.7156 78.4706 17.6152 78.5445 17.5413L78.8234 17.8202ZM80.5715 19.5683L80.8504 19.8471C80.7764 19.9211 80.6761 19.9627 80.5715 19.9627C80.4669 19.9627 80.3665 19.9211 80.2926 19.8471L80.5715 19.5683ZM85.2892 14.8495L85.0103 14.5706C85.1231 14.4578 85.2928 14.424 85.4402 14.4851C85.5875 14.5461 85.6837 14.69 85.6837 14.8495H85.2892ZM85.2892 23.7489V24.1433C85.0714 24.1433 84.8948 23.9667 84.8948 23.7489H85.2892ZM87.8429 23.7489H88.2374C88.2374 23.9667 88.0608 24.1433 87.8429 24.1433V23.7489ZM87.8429 15.0565H87.4485C87.4485 14.897 87.5446 14.7532 87.692 14.6921C87.8394 14.6311 88.009 14.6648 88.1218 14.7776L87.8429 15.0565ZM92.3537 19.5673L92.6325 19.8463C92.4785 20.0002 92.2288 20.0002 92.0748 19.8462L92.3537 19.5673ZM94.1017 17.8202L94.3807 17.5413C94.4546 17.6153 94.4962 17.7157 94.4962 17.8203C94.4961 17.9249 94.4545 18.0252 94.3806 18.0992L94.1017 17.8202ZM89.631 13.3485L89.3521 13.6274C89.2393 13.5146 89.2056 13.3449 89.2666 13.1976C89.3277 13.0502 89.4715 12.9541 89.631 12.9541V13.3485ZM97.1252 13.3485H97.5196C97.5196 13.5664 97.343 13.7429 97.1252 13.7429V13.3485ZM97.1252 10.7948V10.4004C97.343 10.4004 97.5196 10.577 97.5196 10.7948H97.1252ZM89.3449 10.7948V11.1892C89.1854 11.1892 89.0416 11.0931 88.9805 10.9458C88.9194 10.7984 88.9532 10.6288 89.066 10.5159L89.3449 10.7948ZM94.3078 5.83095L94.5867 5.55205C94.7407 5.70607 94.7407 5.95578 94.5867 6.10982L94.3078 5.83095ZM92.5607 4.08388L92.2818 3.80495C92.4359 3.65094 92.6856 3.65096 92.8396 3.80498L92.5607 4.08388ZM87.8429 8.80067L88.1218 9.0796C88.009 9.19239 87.8394 9.22612 87.692 9.16506C87.5446 9.10401 87.4485 8.96019 87.4485 8.80067H87.8429ZM87.8429 0.394423V0C88.0608 0 88.2374 0.176589 88.2374 0.394423L87.8429 0.394423ZM85.2892 0.394423H84.8948C84.8948 0.176589 85.0714 0 85.2892 0V0.394423ZM85.2892 9.0077L85.0103 9.2866L80.0865 4.36277L80.3654 4.08388L80.6443 3.80498L85.5681 8.7288L85.2892 9.0077ZM80.3654 4.08388L80.6442 4.36285L78.8962 6.10992L78.6174 5.83095L78.3385 5.55197L80.0866 3.8049L80.3654 4.08388ZM78.6174 5.83095L78.8962 5.55202L83.8611 10.5159L83.5822 10.7948L83.3033 11.0737L78.3385 6.10987L78.6174 5.83095ZM83.5822 10.7948V11.1892H75.5295V10.7948V10.4004H83.5822V10.7948ZM75.5295 10.7948H75.9239V13.3485H75.5295H75.135V10.7948H75.5295ZM75.5295 13.3485V12.9541H83.2961V13.3485V13.7429H75.5295V13.3485ZM83.2961 13.3485L83.5749 13.6275L79.1023 18.0991L78.8234 17.8202L78.5445 17.5413L83.0172 13.0696L83.2961 13.3485ZM78.8234 17.8202L79.1023 17.5413L80.8504 19.2894L80.5715 19.5683L80.2926 19.8471L78.5445 18.0991L78.8234 17.8202ZM80.5715 19.5683L80.2925 19.2894L85.0103 14.5706L85.2892 14.8495L85.5682 15.1284L80.8504 19.8471L80.5715 19.5683ZM85.2892 14.8495H85.6837V23.7489H85.2892H84.8948V14.8495H85.2892ZM85.2892 23.7489V23.3545H87.8429V23.7489V24.1433H85.2892V23.7489ZM87.8429 23.7489H87.4485V15.0565H87.8429H88.2374V23.7489H87.8429ZM87.8429 15.0565L88.1218 14.7776L92.6326 19.2884L92.3537 19.5673L92.0748 19.8462L87.564 15.3354L87.8429 15.0565ZM92.3537 19.5673L92.0749 19.2883L93.8229 17.5412L94.1017 17.8202L94.3806 18.0992L92.6325 19.8463L92.3537 19.5673ZM94.1017 17.8202L93.8228 18.0991L89.3521 13.6274L89.631 13.3485L89.91 13.0697L94.3807 17.5413L94.1017 17.8202ZM89.631 13.3485V12.9541H97.1252V13.3485V13.7429H89.631V13.3485ZM97.1252 13.3485H96.7307V10.7948H97.1252H97.5196V13.3485H97.1252ZM97.1252 10.7948V11.1892H89.3449V10.7948V10.4004H97.1252V10.7948ZM89.3449 10.7948L89.066 10.5159L94.0289 5.55207L94.3078 5.83095L94.5867 6.10982L89.6238 11.0737L89.3449 10.7948ZM94.3078 5.83095L94.0289 6.10984L92.2818 4.36277L92.5607 4.08388L92.8396 3.80498L94.5867 5.55205L94.3078 5.83095ZM92.5607 4.08388L92.8396 4.3628L88.1218 9.0796L87.8429 8.80067L87.5641 8.52174L92.2818 3.80495L92.5607 4.08388ZM87.8429 8.80067H87.4485V0.394423H87.8429H88.2374V8.80067H87.8429ZM87.8429 0.394423V0.788845H85.2892V0.394423V0H87.8429V0.394423ZM85.2892 0.394423H85.6837V9.0077H85.2892H84.8948V0.394423H85.2892Z",
    fill: "#5170FF",
    mask: "url(#path-40-outside-4_0_4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.711241a33a05259edcdd38c25c4dfed0.svg";
export { ForwardRef as ReactComponent };